"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_COORDINATES_API_RESPONSE_400 = exports.GET_COORDINATES_API_RESPONSE_200 = void 0;
exports.GET_COORDINATES_API_RESPONSE_200 = {
    total: 19,
    coordinates: [
        { id: 'ATA054', lat: '47.0611', lon: '10.3679' },
        { id: 'ATA053', lat: '47.0611', lon: '10.3679' },
        { id: 'ATI158', lat: '47.075', lon: '10.4038' },
        { id: 'ATI504', lat: '47.06', lon: '10.3661' },
        { id: 'ATI654', lat: '47.0618', lon: '10.3713' },
        { id: 'ATI503', lat: '47.06', lon: '10.3661' },
        { id: 'ATI432', lat: '47.074', lon: '10.4241' },
        { id: 'ATI157', lat: '47.075', lon: '10.4038' },
        { id: 'ATI887', lat: '47.0479', lon: '10.3412' },
        { id: 'ATA052', lat: '47.0611', lon: '10.3679' },
        { id: 'ATI506', lat: '47.0615', lon: '10.3699' },
        { id: 'ATI458', lat: '47.0646', lon: '10.3883' },
        { id: 'ATI434', lat: '47.074', lon: '10.4241' },
        { id: 'ATA051', lat: '47.0611', lon: '10.3679' },
        { id: 'ATI653', lat: '47.0646', lon: '10.377' },
        { id: 'ATI763', lat: '47.0479', lon: '10.3412' },
        { id: 'ATA310', lat: '47.0513', lon: '10.3505' },
        { id: 'ATA311', lat: '47.0513', lon: '10.3505' },
        { id: 'ATA312', lat: '47.0513', lon: '10.3505' },
    ],
    aggregations: {
        accommodationTypes: [
            { accommodationId: 'ACCOM-3', count: 2 },
            { accommodationId: 'ACCOM-1', count: 17 },
        ],
        features: [
            { featureId: 'FILT-11', featureName: null, featureCode: null, count: 19 },
            { featureId: 'FILT-7', featureName: null, featureCode: null, count: 4 },
            { featureId: 'FILT-22', featureName: null, featureCode: null, count: 4 },
            { featureId: 'FILT-3', featureName: null, featureCode: null, count: 17 },
            { featureId: 'FILT-24', featureName: null, featureCode: null, count: 3 },
            { featureId: 'FILT-6', featureName: null, featureCode: null, count: 19 },
            { featureId: 'FILT-4', featureName: null, featureCode: null, count: 1 },
            { featureId: 'FILT-30', featureName: null, featureCode: null, count: 13 },
            { featureId: 'FILT-5', featureName: null, featureCode: null, count: 17 },
            { featureId: 'FILT-31', featureName: null, featureCode: null, count: 4 },
            { featureId: 'FILT-33', featureName: null, featureCode: null, count: 3 },
            { featureId: 'FILT-32', featureName: null, featureCode: null, count: 15 },
            { featureId: 'FILT-20', featureName: null, featureCode: null, count: 2 },
            { featureId: 'FILT-26', featureName: null, featureCode: null, count: 1 },
            { featureId: 'FILT-23', featureName: null, featureCode: null, count: 6 },
        ],
        siteFeatures: [],
        bathrooms: [
            { bathrooms: 1, count: 9 },
            { bathrooms: 2, count: 7 },
            { bathrooms: 3, count: 1 },
            { bathrooms: 4, count: 1 },
            { bathrooms: 6, count: 1 },
        ],
        bedrooms: [
            { bedrooms: 0, count: 1 },
            { bedrooms: 1, count: 4 },
            { bedrooms: 2, count: 8 },
            { bedrooms: 3, count: 2 },
            { bedrooms: 4, count: 1 },
            { bedrooms: 5, count: 2 },
            { bedrooms: 6, count: 1 },
        ],
        regions: { rhs1: [], rhs2: [], rhs3: [], rhs4: [], rhs5: [] },
        grades: [
            { grade: '3', count: 15 },
            { grade: '4', count: 4 },
        ],
    },
};
exports.GET_COORDINATES_API_RESPONSE_400 = {
    type: 'VALIDATION_ERROR',
    errors: [
        {
            message: 'locationTag is not supported when brand is cottages.com',
        },
    ],
};
//# sourceMappingURL=coordinates.js.map